import { useMemo } from 'react';
import { useStore } from 'zustand';
import { themeController } from './themeController';

export type { Theme } from './themeController';

export const useTheme = () => {
  const theme = useStore(themeController.store, (state) => state.theme);
  return useMemo(() => ({ theme, toggleTheme: themeController.toggle }), [theme]);
};
